interface LetterItem {
    letter: string;
    hasItems: boolean;
}

interface Props {
    letters: LetterItem[];
    selectedLetter: string;
}

/**
 * Verwaltet die alphabetische Filter-Logik
 * Zuständig für Buchstabenauswahl und CSS-Klassen-Management
 */
export function useAlphabetList(
    props: Props,
    emit: (event: 'select-letter', letter: string) => void
) {

    /**
     * Verarbeitet die Auswahl eines Buchstabens
     */
    const onSelect = (item: LetterItem) => {
        if (!item.hasItems) return;
        emit('select-letter', item.letter);
    };

    /**
     * Bestimmt die CSS-Klassen für einen Buchstaben
     */
    const getLetterClasses = (item: LetterItem): string[] => {
        const classes: string[] = [];

        if (!item.hasItems) {
            classes.push('disabledLink');
        }

        if (item.letter === props.selectedLetter) {
            classes.push('selected');
        }

        return classes;
    };

    return {
        onSelect,
        getLetterClasses
    };
}